module.exports = __webpack_public_path__ + "static/media/WaveIcon.5cfa0379.svg";